import script from "./CompletedModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletedModal.vue?vue&type=script&setup=true&lang=ts"

import "./CompletedModal.vue?vue&type=style&index=0&id=4f8efba2&scoped=true&lang=css"
import "./CompletedModal.vue?vue&type=style&index=1&id=4f8efba2&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8efba2"]])

export default __exports__